{
  "title": "Familles de modèles",
  "create": "Créer",
  "modelFamilyName": "Nom de la famille de modèles",
  "description": "Description",
  "core": "Principal",
  "status": "Statut",
  "states": {
    "draft": "Brouillon",
    "active": "Actif",
    "archived": "Archivé",
    "any": "Tous"
  },
  "filters": {
    "search": "Rechercher",
    "state": "Statut",
    "core": "Principal"
  },
  "coreFilter": {
    "any": "Tous",
    "yes": "Oui",
    "no": "Non"
  },
  "updateFamilyModal": {
    "title": "Mettre à jour la famille",
    "key": "Clé",
    "name": "Nom",
    "description": "Description",
    "shortDescription": "Courte description",
    "state": "État",
    "core": "Principal",
    "icon": "Icône",
    "success": "Famille de modèles mise à jour avec succès",
    "error": "Échec de la mise à jour de la famille de modèles",
    "transitionError": "Échec de la mise à jour de l'état",
    "stateArchivedHint": "Les familles de modèles archivées ne peuvent pas être passées à un autre statut.",
    "rootPresetReadOnlyHint": "Les familles de modèles de l'organisation racine sont prédéfinies pour tous les utilisateurs et ne peuvent pas être modifiées.",
    "unableToArchiveError": "Impossible d'archiver. Cette famille de modèles est actuellement attribuée à des portefeuilles actifs."
  },
  "createFamilyModal": {
    "title": "Créer une famille de modèles",
    "key": "Clé",
    "name": "Nom",
    "description": "Description",
    "shortDescription": "Courte description",
    "core": "Principal",
    "icon": "Icône",
    "success": "Famille de modèles créée avec succès",
    "error": "Échec de la création de la famille de modèles"
  },
  "actions": {
    "edit": "Modifier la famille de modèles",
    "activate": "Activer la famille de modèles",
    "draft": "Passer en brouillon",
    "archive": "Archiver",
    "editTooltip": "Modifier la famille de modèles"
  },
  "tabs": {
    "details": "Détails",
    "auditLog": "Journal d'audit"
  },
  "a11y": {
    "tableLabel": "Tableau des familles de modèles",
    "expandRow": "Développer la famille de modèles",
    "collapseRow": "Réduire la famille de modèles",
    "moreActions": "Plus d'actions"
  },
  "unsavedChanges": {
    "title": "Annuler les modifications non enregistrées?",
    "body": "Vous avez des modifications non enregistrées pour cette famille de modèles. Quitter cette vue ou modifier la liste les annulera.",
    "discard": "Annuler les modifications"
  }
}
